import styled from "styled-components";
import { fanduel } from "@fanduel/formation-tokens";

export const PromoSlotsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: start;

  > div:first-child {
    margin-top: 0;
  }

  @media only screen and (max-width: 699px) {
    > div:last-child {
      margin-bottom: 0;
    }
  }
`;

export const PromoSlotsWrapper = styled.div`
  display: block;
  padding: var(--fd-space-space-4);
  max-width: ${fanduel.breakpoints.desktop}px;

  @media only screen and (min-width: 1024px) {
    min-width: ${fanduel.breakpoints.desktop}px;
  }
`;

export const HeaderContainer = styled.div`
  display: block;
  padding: var(--fd-space-space-4) var(--fd-space-space-4) 0;
`;
